import { render, staticRenderFns } from "./Cropmarketalaysis.vue?vue&type=template&id=53bef994&"
import script from "./Cropmarketalaysis.vue?vue&type=script&lang=js&"
export * from "./Cropmarketalaysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports